module.exports = __webpack_public_path__ + "@/assets/img/btn-macos.fad1bc9d.svg";